import styled from 'styled-components';
import { Card } from '../../style';

export const SummaryGrid = styled.div`
  grid-column: span 12;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const StyledSummaryCard = styled(Card)`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const IconWrapper = styled.div<{ colorClass: 'green' | 'blue' | 'light-blue' }>`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ colorClass }) => colorClass === 'green' && `
    background-color: #e8f5e9;
    color: #4caf50;
  `}
  
  ${({ colorClass }) => colorClass === 'blue' && `
    background-color: #e3f2fd;
    color: #2196f3;
  `}
  
  ${({ colorClass }) => colorClass === 'light-blue' && `
    background-color: #f0f4f8;
    color: #607d8b;
  `}
`;

export const SummaryInfo = styled.div`
  h3 {
    font-size: 14px;
    color: #666;
    margin: 0 0 4px 0;
    font-weight: 500;
  }
`;

export const SummaryValue = styled.p`
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
`;

export const SummarySubtext = styled.p`
  font-size: 12px;
  color: #999;
  margin: 4px 0 0 0;
`;
